import React from "react";
import "./resume.css";

const ResumeCard = ({
  badge,
  title,
  subTitle,
  des,
  keypoints,
  mainHeading,
}) => {
  return (
    <div className="w-full py-6 flex flex-col gap-2.5 border-b-[1px] border-b-zinc-800">
      {badge === "" ? (
        <h6 className="w-30 text-center text-sm py-[1px] text-designColor border-[1px] border-designColor rounded-sm">
          Jan 2024 - Present
        </h6>
      ) : (
        <h6 className="w-30 text-center text-sm py-[1px] text-[#999] border-[1px] border-zinc-600 rounded-sm">
          {badge}
        </h6>
      )}
      <h2 className="text-lg font-titleFont text-gray-200 font-medium">
        {title}
      </h2>
      <p className="text-sm text-[#999] -mt-2">{subTitle}</p>
      <p className="text-base text-[#999] font-medium pr-10">{des}</p>
      {keypoints !== "" && (
        <div>
          {mainHeading === "" ? (
            <h2 className="text-lg font-titleFont text-gray-200 font-medium">
              Key Skills and Responsibilities:
            </h2>
          ) : (
            <h2 className="text-lg font-titleFont text-gray-200 font-medium">
              {mainHeading}
            </h2>
          )}

          <ul>
            {keypoints.map((eachskill) => (
              <li key={eachskill.title}>
                <b className="text-designColor skill-title">
                  {eachskill.title}
                </b>{" "}
                <span className="skill-desc">{eachskill.desc}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ResumeCard;
